import React from 'react';

function MarketingFooter({ onNavigate }) {
  const go = (page) => () => onNavigate && onNavigate(page);
  const year = new Date().getFullYear();

  return (
    <footer className="marketing-footer" role="contentinfo">
      <div className="marketing-footer-inner">
        <div className="marketing-footer-brand">
          <button
            type="button"
            className="marketing-brand"
            onClick={go('home')}
            aria-label="RiskLo home"
          >
            <span className="marketing-brand-mark" aria-hidden="true">
              <img src="/RiskLo_LogoOnly.png" alt="" />
            </span>
            <span className="marketing-brand-text">RiskLo<sup className="reg-mark">®</sup></span>
          </button>
          <p>
            Strategy risk assessment built for prop-firm and futures traders.
            Understand blowout risk, consistency limits, and portfolio exposure
            before you take the trade.
          </p>
        </div>

        <div className="marketing-footer-col">
          <h5>Product</h5>
          <ul>
            <li><button type="button" onClick={go('features')}>Features</button></li>
            <li><button type="button" onClick={go('companies')}>For Companies</button></li>
            <li><button type="button" onClick={go('pricing')}>Pricing</button></li>
            <li><button type="button" onClick={go('how-we-calculate')}>How we calculate</button></li>
            <li><button type="button" onClick={go('tutorials')}>Tutorials</button></li>
            <li><button type="button" onClick={go('how-to-export-csv')}>Export NinjaTrader CSV</button></li>
          </ul>
        </div>

        <div className="marketing-footer-col">
          <h5>Company</h5>
          <ul>
            <li><button type="button" onClick={go('about')}>About</button></li>
            <li><button type="button" onClick={go('help')}>FAQ</button></li>
            <li><button type="button" onClick={go('consistency-rules')}>Consistency rules</button></li>
            <li><button type="button" onClick={go('security')}>Security</button></li>
            <li><button type="button" onClick={go('contact')}>Contact</button></li>
          </ul>
        </div>

        <div className="marketing-footer-col">
          <h5>Get started</h5>
          <ul>
            <li><button type="button" onClick={go('login')}>Sign in</button></li>
            <li><button type="button" onClick={go('login')}>Create account</button></li>
            <li><button type="button" onClick={go('pricing')}>Start free trial</button></li>
          </ul>
        </div>
      </div>

      <div className="marketing-footer-bottom">
        <span>© {year} Cultivate Dynamics LLC. All rights reserved. RiskLo® is a registered trademark of Cultivate Dynamics LLC.</span>
        <div className="marketing-footer-bottom-links">
          <button type="button" onClick={go('privacy-policy')}>Privacy</button>
          <button type="button" onClick={go('terms-and-conditions')}>Terms</button>
          <button type="button" onClick={go('security')}>Security</button>
        </div>
      </div>
    </footer>
  );
}

export default MarketingFooter;
